function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { TextInput } from '../../input';
import Dropdown from '../dropdown';
import { ArrowButton, InputBoxWithArrowButton } from './style';

class InputBoxDropDown extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      isOpen: false
    });

    _defineProperty(this, "arrowButtonRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "handleOnChange", change => {
      this.props.onChange(change);
    });

    _defineProperty(this, "handleOnInputClick", () => {
      this.setState({
        isOpen: true
      });
    });

    _defineProperty(this, "handleOnDropdownClick", () => {
      this.setState({
        isOpen: false
      });
    });

    _defineProperty(this, "getDisplayValue", () => {
      var displayValue;

      if (this.props.itemList) {
        var currentItem = this.props.itemList.find(item => {
          if (typeof item === 'object') {
            return item.value === this.props.value;
          }

          return false;
        });
        displayValue = currentItem === null || currentItem === void 0 ? void 0 : currentItem.display;
      }

      return displayValue;
    });
  }

  render() {
    var _this$props$options, _this$props$options2;

    var textInputOptions = {
      required: (_this$props$options = this.props.options) === null || _this$props$options === void 0 ? void 0 : _this$props$options.required,
      requiredError: (_this$props$options2 = this.props.options) === null || _this$props$options2 === void 0 ? void 0 : _this$props$options2.requiredError
    };
    var hideArrowButton = !!this.props.onInfoIconClick && this.props.value === '' && !this.state.isOpen;
    var displayValue = this.getDisplayValue();
    return /*#__PURE__*/React.createElement(Dropdown, {
      name: this.props.name,
      value: this.props.value,
      onChange: this.handleOnChange,
      itemList: this.props.itemList,
      numberOfItemsToBeShown: this.props.numberOfItemsToBeShown,
      wrapsTextInput: true,
      onInputClick: this.handleOnInputClick,
      onDropdownClick: this.handleOnDropdownClick,
      closeButtonElement: this.arrowButtonRef.current
    }, /*#__PURE__*/React.createElement(InputBoxWithArrowButton, null, /*#__PURE__*/React.createElement(TextInput, {
      options: textInputOptions,
      label: this.props.label,
      focusedLabel: this.props.focusedLabel,
      unfocusedLabel: this.props.unfocusedLabel,
      name: this.props.name,
      value: displayValue || this.props.value,
      autoComplete: 'nope',
      disableErrorMessage: false,
      interactableReadOnly: true,
      error: this.props.error,
      enableError: this.props.enableError,
      textSize: this.props.textSize,
      unfocusedLabelTextSize: this.props.unfocusedLabelTextSize,
      onInfoIconClick: this.props.onInfoIconClick,
      tooltipConfig: this.props.tooltipConfig
    }), /*#__PURE__*/React.createElement(ArrowButton, {
      forwardRef: this.arrowButtonRef,
      hide: hideArrowButton,
      icon: this.state.isOpen ? 'ArrowUp' : 'ArrowDown',
      size: 16
    })));
  }

}

export default InputBoxDropDown;